import { fetchApiGraphQL } from "@/utils/fetcher";
import { hasValidToken } from "@sitecorecomponents/Users/Store/tokenstore";

const getUnreadMessages = `
  query GetUnreadMessages {
    me {
      unreadMessages {
        id
      }
    }
  }
`;

type UnreadMessagesResponse = {
  data?: { me?: { unreadMessages?: unknown[] } };
};

/** Red dot on the header profile button. Lives outside preact, so the messages
 *  island drives it directly as threads are read. */
export function setUnreadMessageIndicator(hasUnreadMessages: boolean) {
  const indicator = document.querySelector<HTMLElement>('[unread-message-indicator]');
  if (indicator) {
    indicator.hidden = !hasUnreadMessages;
  }
}

export async function refreshUnreadMessageIndicator() {
  if (!hasValidToken()) {
    return;
  }

  try {
    const response = await fetchApiGraphQL<UnreadMessagesResponse>(getUnreadMessages, {});
    setUnreadMessageIndicator(!!response?.data?.me?.unreadMessages?.length);
  } catch (err) {
    // The profile menu must remain available even if the notification lookup fails.
    console.log('Error while looking up unread messages', err);
  }
}
